import React from 'react'
import PropTypes from 'prop-types'
import useProvidersStore from 'stores/providers'

import { Button } from 'ui/styled'

const ActionButtons = ({
  path = '',
  entity = {},
  onSelect,
  entityType = ''
}) => {
  const providerNpiList = useProvidersStore(state =>
    state.providers.map(provider => provider.npi_id)
  )
  const isSelected = providerNpiList?.includes(entity?.npi_id)

  return (
    <>
      <Button
        onClick={() => onSelect(entity)}
        margin="0 10px 0 0"
        minwidth="130px"
        data-test="selectProviderBtn"
        btntype="primary"
        disabled={isSelected}
      >
        {isSelected ? 'Selected' : `Select ${entityType}`}
      </Button>
      <Button
        onClick={() => window.open(`${path}${entity.id}`)}
        data-test="viewProviderProfileBtn"
      >
        View Profile
      </Button>
    </>
  )
}

ActionButtons.propTypes = {
  path: PropTypes.string,
  entity: PropTypes.object,
  onSelect: PropTypes.func.isRequired,
  entityType: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
}

export default ActionButtons
